<template>
<div role="group" class="b-form-group form-group">
  <div class="form-row">
    <div class="col-sm-6">
      <b-form-fieldset v-bind:label="$t('NAME')">
        <inputvalidation :formerror="formError" name="companyName">
          <b-form-input type="text" v-model="formData.companyName"></b-form-input>
        </inputvalidation>
      </b-form-fieldset>
    </div>
    <div class="col-sm-6">
      <b-form-fieldset v-bind:label="$t('ADDRESS')">
        <inputvalidation :formerror="formError" name="address">
          <b-form-input type="text" v-model="formData.address"></b-form-input>
        </inputvalidation>
      </b-form-fieldset>
    </div>
  </div>
  <div class="form-row">
    <div class="col-sm-6">
      <b-form-fieldset v-bind:label="$t('POSTALCODE')">
        <inputvalidation :formerror="formError" name="postalCode">
          <b-form-input type="text" v-model="formData.postalCode"></b-form-input>
        </inputvalidation>
      </b-form-fieldset>
    </div>
    <div class="col-sm-6">
      <b-form-fieldset v-bind:label="$t('CITY')">
        <inputvalidation :formerror="formError" name="city">
          <b-form-input type="text" v-model="formData.city"></b-form-input>
        </inputvalidation>
      </b-form-fieldset>
    </div>
  </div>
  <div class="form-row">
    <div class="col-sm-6">
      <b-form-fieldset v-bind:label="$t('TAXNUMBER')">
        <inputvalidation :formerror="formError" name="taxNumber">
          <b-form-input type="text" v-model="formData.taxNumber"></b-form-input>
        </inputvalidation>
      </b-form-fieldset>
    </div>
    <div class="col-sm-6">
      <b-form-fieldset v-bind:label="$t('PHONE')">
        <inputvalidation :formerror="formError" name="phone">
          <b-form-input type="text" v-model="formData.phone"></b-form-input>
        </inputvalidation>
      </b-form-fieldset>
    </div>
  </div>
  <div class="form-row">
    <div class="col-sm-6">
      <b-form-fieldset v-bind:label="$t('COUNTRY')">
        <inputvalidation :formerror="formError" name="country">
          <b-form-input type="text" v-model="formData.country"></b-form-input>
        </inputvalidation>
      </b-form-fieldset>
    </div>
    <div class="col-sm-6">
      <b-form-fieldset v-bind:label="$t('IBAN')">
        <inputvalidation :formerror="formError" name="iban">
          <b-form-input type="text" v-model="formData.iban"></b-form-input>
        </inputvalidation>
      </b-form-fieldset>
    </div>
  </div>
  <div class="form-row">
    <div class="col-sm-6">
      <b-form-fieldset v-bind:label="$t('DISABLEFLOW')">
        <inputvalidation :formerror="formError" name="disableDetails">
            <b-form-checkbox v-model="formData.disableDetails" :value="1" :unchecked-value="0">{{$t('DISABLEFLOW')}}</b-form-checkbox>
        </inputvalidation>
      </b-form-fieldset>
    </div>
  </div>
</div>
</template>

<script>
export default {
    name: 'Companies',
    props: ['formData', 'formError'],
};
</script>
